import axios from '@/plugins/axios'
import { SET_PRODUCTION_QNA_LIST, SET_PRODUCTION_QNA_DETAIL } from '@/store/mutation_types'

const state = {
  productionQnaModel: {},
  productionQnaDetail: {}
}

const getters = {
  productionQnaListData: state => state.productionQnaModel,
  productionQnaDetail: state => state.productionQnaDetail
}

const actions = {
  async getProductionQnaList ({ commit }, params) {
    const config = {
      method: 'GET',
      url: '/_p/production/qnas',
      params: {
        filters: {},
        ...params
      }
    }
    await axios(config).then((response) => {
      commit(SET_PRODUCTION_QNA_LIST, response)
    })
  },
  async getProductionQnaItemDetail ({ commit }, { id }) {
    const config = {
      method: 'GET',
      url: `/_p/production/qnas/${id}`
    }
    await axios(config).then(response => {
      commit(SET_PRODUCTION_QNA_DETAIL, response)
    })
  },
  async saveProductionQnaItem ({ commit }, { id, data }) {
    const setting = {
      method: 'PUT',
      url: `/_p/production/qnas/${id}`,
      data: {
        ...data
      }
    }
    const result = await axios(setting)
    return result
  },
  async deleteProductionQnaItem ({ commit }, { id }) {
    const setting = {
      method: 'DELETE',
      url: `/_p/production/qnas/${id}`
    }
    const result = await axios(setting)
    return result
  }
}

const mutations = {
  [SET_PRODUCTION_QNA_LIST]: (state, payload) => {
    state.productionQnaModel = payload
  },
  [SET_PRODUCTION_QNA_DETAIL]: (state, payload) => {
    state.productionQnaDetail = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
